import React from 'react';

export default function SlackIcon({ className = '' }) {
  return (
    <span className={className}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.83225 14.534C4.83225 15.8638 3.74593 16.9502 2.41612 16.9502C1.08632 16.9502 0 15.8638 0 14.534C0 13.2042 1.08632 12.1179 2.41612 12.1179H4.83225V14.534Z"
          fill="#E01E5A"
        />
        <path
          d="M6.04968 14.534C6.04968 13.2042 7.136 12.1179 8.46581 12.1179C9.79561 12.1179 10.8819 13.2042 10.8819 14.534V20.5837C10.8819 21.9135 9.79561 22.9998 8.46581 22.9998C7.136 22.9998 6.04968 21.9135 6.04968 20.5837V14.534Z"
          fill="#E01E5A"
        />
        <path
          d="M8.46581 4.83225C7.136 4.83225 6.04968 3.74593 6.04968 2.41612C6.04968 1.08632 7.136 0 8.46581 0C9.79561 0 10.8819 1.08632 10.8819 2.41612V4.83225H8.46581Z"
          fill="#36C5F0"
        />
        <path
          d="M8.4658 6.0498C9.7956 6.0498 10.8819 7.13612 10.8819 8.46593C10.8819 9.79573 9.7956 10.8821 8.4658 10.8821H2.41612C1.08632 10.8821 0 9.79573 0 8.46593C0 7.13612 1.08632 6.0498 2.41612 6.0498H8.4658Z"
          fill="#36C5F0"
        />
        <path
          d="M18.1676 8.46691C18.1676 7.1371 19.2539 6.05078 20.5837 6.05078C21.9135 6.05078 22.9998 7.1371 22.9998 8.46691C22.9998 9.79671 21.9135 10.883 20.5837 10.883H18.1676V8.46691Z"
          fill="#2EB67D"
        />
        <path
          d="M16.9503 8.4658C16.9503 9.7956 15.864 10.8819 14.5342 10.8819C13.2044 10.8819 12.118 9.7956 12.118 8.4658V2.41612C12.118 1.08632 13.2044 0 14.5342 0C15.864 0 16.9503 1.08632 16.9503 2.41612V8.4658Z"
          fill="#2EB67D"
        />
        <path
          d="M14.5342 18.1687C15.864 18.1687 16.9503 19.255 16.9503 20.5848C16.9503 21.9146 15.864 23.0009 14.5342 23.0009C13.2044 23.0009 12.118 21.9146 12.118 20.5848V18.1687H14.5342Z"
          fill="#ECB22E"
        />
        <path
          d="M14.5342 16.9502C13.2044 16.9502 12.118 15.8638 12.118 14.534C12.118 13.2042 13.2044 12.1179 14.5342 12.1179H20.5838C21.9136 12.1179 23 13.2042 23 14.534C23 15.8638 21.9136 16.9502 20.5838 16.9502H14.5342Z"
          fill="#ECB22E"
        />
      </svg>
    </span>
  );
}
